"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentsHeader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const SearchResultsService_1 = require("../services/SearchResultsService");
const app_1 = require("app");
const getPageTitle = (typeFiltersList, documentsSearchPageType) => {
    const documentsTypeFilter = typeFiltersList.filter(filter => filter &&
        filter.value &&
        SearchResultsService_1.SearchResultsService.getFilterValueItself(filter.value) === documentsSearchPageType)[0];
    return documentsTypeFilter && documentsTypeFilter.title;
};
exports.DocumentsHeader = React.memo(props => {
    const pageTitle = getPageTitle(props.typeFiltersList, props.documentsSearchPageType);
    if (!pageTitle)
        return null;
    return ((0, jsx_runtime_1.jsx)("h1", { className: (0, app_1.cn)(`page-heading text-primary block my-3xl sm:my-5xl`, props.className), children: pageTitle }));
}, () => true);
